import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { getCookie, setCookie, isValidTokenDate } from '../../../utils/utils'
import { config } from '../../../../config/config'
import { renewRefreshToken } from '../../../modern/services/tokenService'

export const TokenContext = createContext({
  accessToken: '',
  refreshToken: '',
  jwtToken: '',
})

export function TokenProvider({ children }) {
  const accessTokenCookie = String(getCookie(config.accessToken) || '')
  const refreshTokenCookie = String(getCookie(config.refreshToken) || '')
  const jwtTokenCookie = String(getCookie(config.cookieJwt) || '')
  const [accessToken, setAccessToken] = useState(accessTokenCookie)
  const [refreshToken, setRefreshToken] = useState(refreshTokenCookie)
  const [jwtToken, setJwtToken] = useState(jwtTokenCookie)

  const updateJWTCookies = useCallback((access, refresh, jwt) => {
    const domain = '.webmotors.com.br'
    const expires = 300

    if (access) {
      setCookie(config.accessToken, access, expires, 0, false, domain)
      setAccessToken(access)
    }
    if (refresh) {
      setCookie(config.refreshToken, refresh, expires, 0, false, domain)
      setRefreshToken(refresh)
    }
    if (jwt) {
      setCookie(config.cookieJwt, jwt, expires, 0, false, domain)
      setJwtToken(jwt)
    }
  }, [])

  const getRefreshToken = useCallback(
    async token => {
      try {
        const apiResponse = await renewRefreshToken(token)

        if (apiResponse.Data) {
          const { AccessToken, RefreshToken, IdToken } = apiResponse.Data

          if (AccessToken && RefreshToken && IdToken) {
            updateJWTCookies(AccessToken, RefreshToken, IdToken)
          } else if (!apiResponse.Success) {
            throw new Error(`[getRefreshToken] Data: , ${apiResponse.Data}`)
          }
        }
      } catch (error) {
        throw new Error(`[getRefreshToken] error: , ${error}`)
      }
    },
    [updateJWTCookies]
  )

  useEffect(() => {
    if (accessToken) {
      const isValidToken = isValidTokenDate(accessToken)

      if (!isValidToken) {
        if (refreshToken) {
          getRefreshToken(refreshToken)
        }
      }
    }
  }, [accessToken, refreshToken, getRefreshToken])

  const value = useMemo(
    () => ({
      accessToken,
      refreshToken,
      jwtToken,
    }),
    [accessToken, refreshToken, jwtToken]
  )

  return <TokenContext.Provider value={value}>{children}</TokenContext.Provider>
}
